import React from "react";
import {
  getWorkerTier,
  getWorkerTierIcon,
} from "../../../utils/workerMetrics";

export default function WorkerRow({
  worker,
  attentionTarget = "",
  onManageWorker,
  onTransferFacility,
}) {
  const uid = worker?.uid || worker?.id || worker?.email;
  const reliabilityScore = Number(worker?.reliabilityScore || 100);
  const ratingCount = Number(worker?.facilityRatingCount || 0);

const facilityRating =
  ratingCount > 0
    ? (
        Number(worker?.facilityRatingTotal || 0) /
        ratingCount
      ).toFixed(1)
    : "5.0";
const tier = getWorkerTier(reliabilityScore);
const tierIcon = getWorkerTierIcon(reliabilityScore);
  const isAttention =
    String(uid || "").toLowerCase() === String(attentionTarget || "").toLowerCase();

  return (
    <div
      id={isAttention ? "workforce-attention-worker" : undefined}
      style={{
        border: isAttention ? "2px solid #2563eb" : "1px solid #e2e8f0",
        borderRadius: 14,
        padding: 12,
        background: isAttention ? "#eff6ff" : "#ffffff",
        display: "grid",
        gridTemplateColumns: "1fr auto",
        gap: 10,
        alignItems: "center",
      }}
    >
      <div>
        <div style={{ fontWeight: 950, color: "#0f172a" }}>
          {worker?.displayName ||
            worker?.fullName ||
            `${worker?.firstName || ""} ${worker?.lastName || ""}`.trim() ||
            worker?.email ||
            "Worker"}
        </div>
        <div style={{ marginTop: 6, fontSize: 11, color: "#166534", fontWeight: 900 }}>
  {tierIcon} {tier} • Reliability {reliabilityScore}%
</div>

<div
  style={{
    marginTop: 3,
    fontSize: 11,
    fontWeight: 800,
    color: "#d97706",
  }}
>
  ⭐ {facilityRating} Facility Rating
</div>

        <div style={{ marginTop: 4, fontSize: 12, color: "#64748b", fontWeight: 800 }}>
          {worker?.email || uid}
        </div>

        <div style={{ marginTop: 6, fontSize: 11, color: "#334155", fontWeight: 900 }}>
          {(worker?.primaryRole || worker?.position || worker?.workerType || "WORKER")} •{" "}
          {(worker?.facilityName || worker?.facilityId || "No facility")}
        </div>
      </div>

  <div
  style={{
    display: "grid",
    gap: 6,
    minWidth: 132,
  }}
>
  <button
    type="button"
    onClick={() => onManageWorker?.(worker)}
    style={{
      border: "1px solid #2563eb",
      background: "#2563eb",
      color: "#fff",
      borderRadius: 10,
      padding: "8px 12px",
      fontWeight: 900,
      cursor: "pointer",
    }}
  >
    Manage Worker
  </button>

  <button
    type="button"
    onClick={() => onTransferFacility?.(worker)}
    style={{
      border: "1px solid #0f766e",
      background: "#f0fdfa",
      color: "#0f766e",
      borderRadius: 10,
      padding: "8px 12px",
      fontWeight: 900,
      cursor: "pointer",
    }}
  >
    Transfer Facility
  </button>
</div>
    </div>
  );
}